import { Icon, IconButton, Steps, Text, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Button } from 'native-base';
import React from 'react';

export interface CardHeaderProps {
  onClose: () => void;
  handleExportPdf?: () => void;
  hasSteps?: boolean;
  currentStep?: number;
  totalSteps?: number;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  onClose,
  handleExportPdf,
  hasSteps,
  currentStep,
  totalSteps,
}) => {
  return (
    <HStack space={Spacing['inline.nano']} alignItems="center" justifyContent="space-between">
      <HStack space={Spacing['inline.nano']} alignItems="center">
        <IconButton
          onPress={onClose}
          icon="ArrowLeft"
          iconSize="xs"
          testId="back"
          iconColor={Color['neutral.black']}
          p={0}
        />

        <Text variant="semibold" color="neutral.black">
          Nova boleta
        </Text>
      </HStack>
      {!!handleExportPdf && (
        <Button
          variant="textLink"
          onPress={handleExportPdf}
          leftIcon={
            <Icon testID="qa" name="Pdf" size="xxxs" color={Color['brand.tertiary.principal']} />
          }>
          EXPORTAR EM PDF
        </Button>
      )}
      {hasSteps && (
        <Steps totalSteps={totalSteps ?? 0} currentStep={currentStep ?? 0} testId="steps" />
      )}
    </HStack>
  );
};
